import { render, staticRenderFns } from "./CUKuli.vue?vue&type=template&id=68e243ea&scoped=true&"
import script from "./CUKuli.vue?vue&type=script&lang=js&"
export * from "./CUKuli.vue?vue&type=script&lang=js&"
import style0 from "./CUKuli.vue?vue&type=style&index=0&id=68e243ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e243ea",
  null
  
)

export default component.exports